import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as PictogramAssets from './PictogramAssets.js';

var _excluded = ["name", "alt", "theme"];
var Pictogram = props => {
  var _imgSrc;
  var {
      name,
      alt,
      theme
      // eslint-disable-line
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  var pictogramName = name;
  var hcid = "".concat(Pictogram.name.toLocaleLowerCase(), "-").concat("10.6.2");

  // The input name could be in short format("Cards48"), long format ("pictogramCards48"), or be a pathname ("pictograms/pictogramCards48.svg")
  // This regex will extract the name (Card) and size (48)
  var pictogramSize = 'small';
  var matches = name.match(/\/?(pictogram)?(([a-z]+)(\d+))(\.svg)?$/i);
  if (matches) {
    pictogramName = matches[2]; // eslint-disable-line

    // Get the size for the classname
    switch (matches[4]) {
      case '40':
        pictogramSize = 'xsmall';
        break;
      case '48':
        pictogramSize = 'small';
        break;
      case '64':
        pictogramSize = 'medium';
        break;
      case '128':
        pictogramSize = 'extralarge';
        break;
    }
  }
  if (typeof alt !== 'string' || alt.length === 0) {
    // Add aria-hidden when there is no alt text
    // @ts-ignore 
    attributes['aria-hidden'] = true;
  }

  // @ts-ignore
  var imgSrc = theme ? PictogramAssets[theme.toLocaleLowerCase() + pictogramName] : PictogramAssets[pictogramName];
  if ((_imgSrc = imgSrc) !== null && _imgSrc !== void 0 && _imgSrc.default) {
    imgSrc = imgSrc.default;
  }

  // Output the pictogram
  return /*#__PURE__*/React.createElement("img", _extends({
    className: "pictogram pictogram--".concat(pictogramSize),
    src: imgSrc,
    alt: alt
  }, attributes, {
    "data-hcid": hcid
  }));
};
Pictogram.defaultProps = {
  alt: ''
};
Pictogram.propTypes = {
  alt: PropTypes.string,
  name: (props, propName, componentName) => {
    // eslint-disable-line
    if (Object.keys(PictogramAssets).concat(Object.keys(PictogramAssets).map(name => "pictogram".concat(name)) // eslint-disable-line
    ).indexOf(props.theme ? "".concat(props.theme).concat(props[propName]) : props[propName]) === -1) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName));
    }
  },
  theme: PropTypes.string
};

export { Pictogram };
